import React from "react";

const Offers = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        Q.
        <span className="text-[#01A7D1] "> OFFERS AND DISCOUNTS</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        1. Yostel provides attractive offers and discounts for new/first time
        Users. You may avail these discounts by using the 'Reserve Now' option
        on our Website.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        2. By selecting the 'Reserve Now' option you may unlock assured
        discounts on payment of a refundable and nominal 'Fee' and schedule a
        visit to our Property/Residence. Upon Your successful onboarding, You
        may avail the unlocked discount only on the rent payable by You for the
        first month of Your stay.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        3. In case You don't wish to onboard after visiting our property, You
        may claim the refund of the 'Fee'.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        4. The discount offered to you will be inclusive of the 'Fee' i.e. the
        initial Fee/payment cannot be claimed separately or over and above the
        total discount offered to You.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        5. The 'Reserve Now' option shall only be applicable if the 'Fee' is
        received by Yostel, at a minimum of 12 (twelve) hours prior to the
        payment of the final booking amount.
      </p>
    </div>
  );
};

export default Offers;
